import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
  IconButton,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Pan from "../../assets/svg/PenEtat.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CircleIcon from "@mui/icons-material/Circle";
import {
  Add,
  Edit,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Square,
} from "@mui/icons-material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DownloadIcon from "@mui/icons-material/Download";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import deleteIcon from "../../assets/svg/delete.png";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";
import "react-image-gallery/styles/css/image-gallery.css";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate, useParams } from "react-router";
import { useForm } from "react-hook-form";
import SelectVehicleModal from "../../components/SelectVehicleModal";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";

// import './NewEQprofile.css';

const NewEQprofile = ({ id }) => {
  const [value, setValue] = useState(0);

  const paginationModel = { page: 0, pageSize: 5 };

  // edits from mostafa -------------------------

  const { eqId } = useParams();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  // *************** inspection section *****************

  // inspection data

  const [inspections, setInspections] = useState([]);

  const getInspections = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/${eqId}/inspections`,
        {
          headers,
        }
      );
      console.log(response.data.data.inspections);
      setInspections(response.data.data.inspections);
    } catch (error) {
      console.log(error);
    }
  };

  const inspectionColumns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.3,
      minWidth: 30,
    },
    {
      field: "type",
      headerName: "Inspection Type",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "name",
      headerName: "Inspector Name",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "date",
      headerName: "Inspection Date",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 100,
      renderCell: (params) => (
        <span
          className={`badge ${
            params.row.status === "passed"
              ? "bg-success"
              : params.row.status === "failed"
              ? "bg-danger"
              : "bg-warning"
          }`}
        >
          {params.row.status}
        </span>
      ),
    },
    {
      field: "notes",
      headerName: "Notes",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const insp = params.row.rawData;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleViewInspection(insp);
              }}
              color="primary"
              aria-label="preview inspection"
              style={{ width: "30%" }}
              size="small"
            >
              <RemoveRedEyeIcon />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                EditInspection(insp);
              }}
              color="default"
              aria-label="edit inspection"
              style={{ width: "30%" }}
              size="small"
            >
              <Edit />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const inspectionRows = inspections.map((ins) => ({
    id: ins.id,
    type: ins.type?.name || "Unknown",
    name: ins.inspector_name || "Unknown",
    date: new Date(ins.inspection_date).toLocaleDateString() || "Unknown",
    status: ins.status || "Unknown",
    notes: ins.notes || "Unknown",
    Actions: "",
    rawData: ins,
  }));

  // add & update inspection

  const [inspectionTypes, setInspectionTypes] = useState([]);

  const getInspectionTypes = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/inspection_types`,
        {
          headers,
        }
      );
      console.log(response.data.data.inspection_types);
      setInspectionTypes(response.data.data.inspection_types);
    } catch (error) {
      console.log(error);
    }
  };

  const [inspectionStatuses, setInspectionStatuses] = useState([]);

  const getInspectionStatuses = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/inspection_statuses`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setInspectionStatuses(response.data.data.inspection_statuses);
    } catch (error) {
      console.log(error);
    }
  };

  const [isEditing, setIsEditing] = useState(false);

  const [images, setImages] = useState([]);

  const [removedImages, setRemovedImages] = useState([]);

  const [editInspectionId, setEditInspectionId] = useState(null);

  const [addInspectionData, setAddInspectionData] = useState({
    type_id: "",
    inspector_name: "",
    inspection_date: "",
    status: "",
    notes: "",
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddInspectionData({
      type_id: "",
      inspector_name: "",
      inspection_date: "",
      status: "",
      notes: "",
    });
    setIsEditing(false);
    setEditInspectionId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditInspectionId(null);
    setImages([]);
  };

  const onSubmitAddInspection = () => {
    const formData = new FormData();
    if (isEditing) {
      formData.append("_method", "PATCH");
    }
    formData.append("type_id", addInspectionData.type_id);
    formData.append("inspector_name", addInspectionData.inspector_name);
    formData.append("status", addInspectionData.status);
    formData.append("inspection_date", addInspectionData.inspection_date);
    formData.append("notes", addInspectionData.notes);

    const existingCount = images.filter((img) => img.isFromBackend).length;

    const newImages = images.filter((img) => !img.isFromBackend && img.file);

    newImages.forEach((img, i) => {
      const idx = existingCount + i;
      formData.append(`images[${idx}]`, img.file);
    });

    removedImages.forEach((id) => {
      formData.append("removed_images[]", String(id));
    });

    const url = isEditing
      ? `${newBaseUrl}/api/portal/equipments/${eqId}/inspections/${editInspectionId}`
      : `${newBaseUrl}/api/portal/equipments/${eqId}/inspections`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "Inspection Updated Successfully"
            : "Inspection Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        setIsEditing(false);
        setImages([]);
        getInspections();
        setAddInspectionData({
          type_id: "",
          inspector_name: "",
          inspection_date: "",
          status: "",
          notes: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const EditInspection = (inspection) => {
    console.log(inspection);
    setAddInspectionData({
      type_id: inspection?.type_id || "",
      inspector_name: inspection?.inspector_name || "",
      inspection_date: inspection?.inspection_date
        ? inspection.inspection_date.split("T")[0]
        : "",
      status: inspection?.status || "",
      notes: inspection?.notes || "",
    });

    const existingImages =
      inspection.images?.map((img) => ({
        id: img.id,
        preview: img.image_url.startsWith("http")
          ? img.image_url
          : `${newBaseUrl}${img.image_url}`,
        file: null,
        isFromBackend: true,
      })) || [];

    setImages(existingImages);

    setInspectionValue("type_id", inspection?.type_id || "");
    setInspectionValue("inspector_name", inspection?.inspector_name || "");
    setInspectionValue("inspection_date", inspection?.inspection_date || "");
    setInspectionValue("status", inspection?.status || "");
    setInspectionValue("notes", inspection?.notes || "");
    setIsEditing(true);
    setEditInspectionId(inspection.id);
    setShow(true);
  };

  const {
    register,
    handleSubmit,
    setValue: setInspectionValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // view inspection images

  const [showInspectionGalleryModal, setShowInspectionGalleryModal] =
    useState(false);
  const [inspectionGalleryTitle, setInspectionGalleryTitle] = useState("");
  const [inspectionGalleryImages, setInspectionGalleryImages] = useState([]);
  const [inspectionSelectedImage, setInspectionSelectedImage] = useState(null);

  const handleViewInspection = (insu) => {
    const images = insu.images || [];
    setInspectionGalleryImages(images);
    setInspectionSelectedImage(images[0] || null);
    setInspectionGalleryTitle(`Preview Inspection Images`);
    setShowInspectionGalleryModal(true);
  };

  const handleCloseInspectionGalleryModal = () => {
    setShowInspectionGalleryModal(false);
    setInspectionSelectedImage(null);
    setInspectionGalleryImages([]);
  };

  const handleDownloadInspectionImage = async (img) => {
    try {
      const imageUrl = `${newBaseUrl}${img.image_url}`;
      console.log("Downloading from:", imageUrl);

      const response = await fetch(imageUrl, {
        mode: "no-cors",
      });

      if (!response.ok && response.type !== "opaque") {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = img.image || "inspection-image";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download image. Check if the image URL is public.");
    }
  };

  // ******************** maintenance section *************************

  // maintenance data

  const [maintenances, setMaintenances] = useState([]);

  const [expandedRow, setExpandedRow] = useState(null);

  const getMaintenances = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/${eqId}/maintenance`,
        {
          headers,
        }
      );
      console.log(response.data.data.maintenance_history);
      setMaintenances(response.data.data.maintenance_history);
    } catch (error) {
      console.log(error);
    }
  };

  const maintenanceColumns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.3,
      minWidth: 30,
    },
    {
      field: "insId",
      headerName: "Inspection Id",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "performed",
      headerName: "Performed By",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "scheduled",
      headerName: "Scheduled Date",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "completed",
      headerName: "Completed Date",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 90,
      renderCell: (params) => (
        <span
          className={`badge ${
            params.row.status === "passed"
              ? "bg-success"
              : params.row.status === "failed"
              ? "bg-danger"
              : "bg-warning"
          }`}
        >
          {params.row.status}
        </span>
      ),
    },
    {
      field: "cost",
      headerName: "Cost",
      flex: 0.8,
      minWidth: 80,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const maint = params.row.rawData;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setExpandedRow(
                  expandedRow === params.row.id ? null : params.row.id
                );
              }}
              color="default"
              aria-label="toggle details"
              size="small"
            >
              {expandedRow === params.row.id ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )}
            </IconButton>

            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                EditMaintenace(maint);
              }}
              color="default"
              aria-label="edit inspection"
              style={{ width: "30%" }}
              size="small"
            >
              <Edit />
            </IconButton>
          </div>
        );
      },
    },
  ];

  // const getDetailPanelContent = React.useCallback(
  //   (params) => (
  //     <Box
  //       sx={{
  //         p: 2,
  //         backgroundColor: "#f9f9f9",
  //         borderTop: "1px solid #ddd",
  //       }}
  //     >
  //       <Typography variant="subtitle1" fontWeight="bold">
  //         Found:
  //       </Typography>
  //       <Typography sx={{ mb: 1 }}>
  //         {params.row.rawData?.found || "No data"}
  //       </Typography>

  //       <Typography variant="subtitle1" fontWeight="bold">
  //         Action Taken:
  //       </Typography>
  //       <Typography>{params.row.rawData?.action_taken || "No data"}</Typography>
  //     </Box>
  //   ),
  //   []
  // );

  // const getDetailPanelHeight = React.useCallback(() => 120, []);

  const maintenanceRows = maintenances?.map((main) => ({
    id: main.id,
    insId: main.inspection?.inspector_name || "Unknown",
    performed: main.performed_by || "Unknown",
    scheduled: new Date(main.scheduled_date).toLocaleDateString() || "Unknown",
    completed: new Date(main.completed_date).toLocaleDateString() || "Unknown",
    type: main.type_display || "Unknown",
    cost: main.cost || "Unknown",
    status: main.status_display || "Unknown",
    Actions: "",
    rawData: main,
  }));

  // add & update maintenance

  const [maintenanceTypes, setMaintenanceTypes] = useState([]);

  const [maintenanceStatuses, setMaintenanceStatuses] = useState([]);

  const getMaintenanceFormData = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/${eqId}/maintenance/form-data`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setMaintenanceStatuses(response.data.data.status_options);
      setMaintenanceTypes(response.data.data.type_options);
    } catch (error) {
      console.log(error);
    }
  };

  const [isMaintenanceEditing, setIsMaintenanceEditing] = useState(false);

  const [editMaintenanceId, setEditMaintenanceId] = useState(null);

  const [addMaintenanceData, setAddMaintenanceData] = useState({
    inspection_id: "",
    performed_by: "",
    status: "",
    type: "",
    issues_found: "",
    actions_taken: "",
    scheduled_at: "",
    completed_date: "",
    cost: "",
  });

  const [showMaintenance, setShowMaintenance] = useState(false);

  const handleShowMaintenance = () => {
    setAddMaintenanceData({
      inspection_id: "",
      performed_by: "",
      status: "",
      type: "",
      issues_found: "",
      actions_taken: "",
      scheduled_at: "",
      completed_date: "",
      cost: "",
    });
    setIsMaintenanceEditing(false);
    setEditMaintenanceId(null);
    setShowMaintenance(true);
  };

  const handleCloseMaintenance = () => {
    setShowMaintenance(false);
    setIsMaintenanceEditing(false);
    setEditMaintenanceId(null);
  };

  const onSubmitAddMaintenace = () => {
    const formData = new FormData();
    if (isMaintenanceEditing) {
      formData.append("_method", "PUT");
    }
    formData.append("inspection_id", addMaintenanceData.inspection_id);
    formData.append("performed_by", addMaintenanceData.performed_by);
    formData.append("status", addMaintenanceData.status);
    formData.append("scheduled_at", addMaintenanceData.scheduled_at);
    formData.append("completed_date", addMaintenanceData.completed_date);
    formData.append("type", addMaintenanceData.type);
    formData.append("cost", addMaintenanceData.cost);
    formData.append("issues_found", addMaintenanceData.issues_found);
    formData.append("actions_taken", addMaintenanceData.actions_taken);

    const url = isMaintenanceEditing
      ? `${newBaseUrl}/api/portal/equipments/${eqId}/maintenance/${editMaintenanceId}`
      : `${newBaseUrl}/api/portal/equipments/${eqId}/maintenance`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isMaintenanceEditing
            ? "Maintenance Updated Successfully"
            : "Maintenance Added Successfully",
          { autoClose: 3000 }
        );
        setShowMaintenance(false);
        setIsMaintenanceEditing(false);
        getMaintenances();
        setAddMaintenanceData({
          inspection_id: "",
          performed_by: "",
          status: "",
          type: "",
          issues_found: "",
          actions_taken: "",
          scheduled_at: "",
          completed_date: "",
          cost: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const EditMaintenace = (maintenance) => {
    console.log(maintenance);
    setAddMaintenanceData({
      inspection_id: maintenance.inspection?.id || "",
      performed_by: maintenance.performed_by || "",
      status: maintenance.status || "",
      type: maintenance.type || "",
      issues_found: maintenance.issues_found || "",
      actions_taken: maintenance.actions_taken || "",
      scheduled_at: maintenance?.scheduled_date
        ? maintenance.scheduled_date.split("T")[0]
        : "",
      completed_date: maintenance?.completed_date
        ? maintenance.completed_date.split("T")[0]
        : "",
      cost: maintenance.cost || "",
    });
    setMaintenanceValue("inspection_id", maintenance?.inspection_id || "");
    setMaintenanceValue("performed_by", maintenance?.performed_by || "");
    setMaintenanceValue("status", maintenance?.status || "");
    setMaintenanceValue("type", maintenance?.type || "");
    setMaintenanceValue("issues_found", maintenance?.issues_found || "");
    setMaintenanceValue("actions_taken", maintenance?.actions_taken || "");
    setMaintenanceValue("scheduled_at", maintenance?.scheduled_at || "");
    setMaintenanceValue("completed_date", maintenance?.completed_date || "");
    setMaintenanceValue("cost", maintenance?.cost || "");
    setIsMaintenanceEditing(true);
    setEditMaintenanceId(maintenance.id);
    setShowMaintenance(true);
  };

  const {
    register: maintenanceRegister,
    handleSubmit: handleSubmitMaintenance,
    setValue: setMaintenanceValue,
    formState: {
      errors: maintenanceErrors,
      isSubmitting: isSubmittingMaintenance,
    },
  } = useForm();

  // *************** insurances section *****************

  // insurances data

  const [insurances, setInsurances] = useState([]);

  const getInsurances = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/${eqId}/insurances`,
        {
          headers,
        }
      );
      console.log(response.data.data.insurances);
      setInsurances(response.data.data.insurances);
    } catch (error) {
      console.log(error);
    }
  };

  const insurancesColumns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.3,
      minWidth: 30,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1.2,
      minWidth: 140,
    },
    {
      field: "provider",
      headerName: "Provider",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "policy",
      headerName: "Policy No.",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "expiry",
      headerName: "Expiry Date",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.8,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const insu = params.row.rawData;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleViewInsurance(insu);
              }}
              color="primary"
              aria-label="preview inspection"
              style={{ width: "30%" }}
              size="small"
            >
              <RemoveRedEyeIcon />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                EditInsurance(insu);
              }}
              color="default"
              aria-label="edit inspection"
              style={{ width: "30%" }}
              size="small"
            >
              <Edit />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const insurancesnRows = insurances?.map((ins) => ({
    id: ins.id,
    type: ins.type?.name || "Unknown",
    provider: ins.provider || "Unknown",
    amount: ins.amount || "Unknown",
    policy: ins.policy_number || "Unknown",
    expiry: new Date(ins.expiry_date).toLocaleDateString() || "Unknown",
    Actions: "",
    rawData: ins,
  }));

  // add & update insurance

  const [insurancesTypes, setInsurancesTypes] = useState([]);

  const getInsurancesTypes = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/insurance_types`,
        {
          headers,
        }
      );
      console.log(response.data.data.insurance_types);
      setInsurancesTypes(response.data.data.insurance_types);
    } catch (error) {
      console.log(error);
    }
  };

  const [isInsuranceEditing, setIsInsuranceEditing] = useState(false);

  const [insuranceImages, setInsuranceImages] = useState([]);

  const [insuranceRemovedImages, setInsuranceRemovedImages] = useState([]);

  const [editInsuranceId, setEditInsuranceId] = useState(null);

  const [addInsuranceData, setAddInsuranceData] = useState({
    type_id: "",
    provider: "",
    amount: "",
    policy_number: "",
    expiry_date: "",
    comment: "",
  });

  const [showInsurance, setShowInsurance] = useState(false);

  const handleShowInsurance = () => {
    setAddInsuranceData({
      type_id: "",
      provider: "",
      amount: "",
      policy_number: "",
      expiry_date: "",
      comment: "",
    });
    setIsInsuranceEditing(false);
    setEditInsuranceId(null);
    setShowInsurance(true);
  };

  const handleCloseInsurance = () => {
    setShowInsurance(false);
    setIsInsuranceEditing(false);
    setEditInsuranceId(null);
    setInsuranceImages([]);
  };

  const onSubmitAddInsurance = () => {
    const formData = new FormData();
    if (isInsuranceEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("type_id", addInsuranceData.type_id);
    formData.append("provider", addInsuranceData.provider);
    formData.append("amount", addInsuranceData.amount);
    formData.append("policy_number", addInsuranceData.policy_number);
    formData.append("expiry_date", addInsuranceData.expiry_date);
    formData.append("comment", addInsuranceData.comment);

    const existingCount = insuranceImages.filter(
      (img) => img.isFromBackend
    ).length;

    const newImages = insuranceImages.filter(
      (img) => !img.isFromBackend && img.file
    );

    newImages.forEach((img, i) => {
      const idx = existingCount + i;
      formData.append(`images[${idx}]`, img.file);
    });

    insuranceRemovedImages.forEach((id) => {
      formData.append("removed_images[]", String(id));
    });

    const url = isInsuranceEditing
      ? `${newBaseUrl}/api/portal/equipments/${eqId}/insurances/${editInsuranceId}`
      : `${newBaseUrl}/api/portal/equipments/${eqId}/insurances`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isInsuranceEditing
            ? "Insurance Updated Successfully"
            : "Insurance Added Successfully",
          { autoClose: 3000 }
        );
        setShowInsurance(false);
        setIsInsuranceEditing(false);
        setInsuranceImages([]);
        getInsurances();
        setAddInsuranceData({
          type_id: "",
          provider: "",
          amount: "",
          policy_number: "",
          expiry_date: "",
          comment: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const EditInsurance = (insurance) => {
    console.log(insurance);
    setAddInsuranceData({
      type_id: insurance?.type_id || "",
      provider: insurance?.provider || "",
      expiry_date: insurance?.expiry_date
        ? insurance.expiry_date.split("T")[0]
        : "",
      policy_number: insurance?.policy_number || "",
      amount: insurance?.amount || "",
      comment: insurance?.comment || "",
    });

    const existingImages =
      insurance.images?.map((img) => ({
        id: img.id,
        preview: img.image_url.startsWith("http")
          ? img.image_url
          : `${newBaseUrl}${img.image_url}`,
        file: null,
        isFromBackend: true,
      })) || [];

    setInsuranceImages(existingImages);

    setInsuranceValue("type_id", insurance?.type_id || "");
    setInsuranceValue("provider", insurance?.provider || "");
    setInsuranceValue("expiry_date", insurance?.expiry_date || "");
    setInsuranceValue("amount", insurance?.amount || "");
    setInsuranceValue("policy_number", insurance?.policy_number || "");
    setInsuranceValue("comment", insurance?.comment || "");
    setIsInsuranceEditing(true);
    setEditInsuranceId(insurance.id);
    setShowInsurance(true);
  };

  const {
    register: insuranceRegister,
    handleSubmit: handleSubmitInsurance,
    setValue: setInsuranceValue,
    formState: { errors: insuranceErrors, isSubmitting: isInsuranceSubmitting },
  } = useForm();

  // view insurance images

  const [showInsranceGalleryModal, setShowInsuranceGalleryModal] =
    useState(false);
  const [insuranceGalleryTitle, setInsuranceGalleryTitle] = useState("");
  const [insuranceGalleryImages, setInsuranceGalleryImages] = useState([]);
  const [insuranceSelectedImage, setInsuranceSelectedImage] = useState(null);

  const handleViewInsurance = (insu) => {
    const images = insu.images || [];
    setInsuranceGalleryImages(images);
    setInsuranceSelectedImage(images[0] || null);
    setInsuranceGalleryTitle(`Preview Insurance Images`);
    setShowInsuranceGalleryModal(true);
  };

  const handleCloseInsuranceGalleryModal = () => {
    setShowInsuranceGalleryModal(false);
    setInsuranceSelectedImage(null);
    setInsuranceGalleryImages([]);
  };

  const handleDownloadImage = async (img) => {
    try {
      const imageUrl = `${newBaseUrl}${img.image_url}`;
      console.log("Downloading from:", imageUrl);

      const response = await fetch(imageUrl, {
        mode: "no-cors",
      });

      if (!response.ok && response.type !== "opaque") {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = img.image || "insurance-image";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download image. Check if the image URL is public.");
    }
  };

  // ******************** equipment data for side *********************

  const [equipmentInfo, setEquipmentInfo] = useState(null);

  const getEquipmentInfo = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/${eqId}`,
        {
          headers,
        }
      );
      console.log(response.data.data.equipment);
      setEquipmentInfo(response.data.data.equipment);
    } catch (error) {
      console.log(error);
    }
  };

  // ******************** delete equipment data for side *********************

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const confirmDelete = () => {
    setShowDelete(true);
  };

  const deleteEquipment = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/equipments/${eqId}`,
        {
          headers,
        }
      );
      toast.warning("Equipment Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      navigate("/AllEquipments");
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  // ********************* assign & unassign ****************************

  // assign

  const [showVehicleModal, setShowVehicleModal] = useState(false);

  const handleAssignShow = () => {
    setShowVehicleModal(true);
  };

  const handleAssignHide = () => {
    setShowVehicleModal(false);
  };

  // unassign

  const [showUnassign, setShowUnassign] = useState(false);

  const handleUnassignShow = () => {
    setShowUnassign(true);
  };

  const handleUnassignClose = () => {
    setShowUnassign(false);
  };

  const unassignEquipment = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/equipments/${eqId}/vehicles/${equipmentInfo?.current_vehicle?.id}/detach`,
        {
          headers,
        }
      );
      toast.warning("Equipment Unassigned successfully", { autoClose: 3000 });
      console.log(response);
      getEquipmentInfo();
      handleUnassignClose();
    } catch (error) {
      toast.error("Failed To Unassign This Equipment.");
      console.log(error.message);
    }
  };

  // ******************************** effects ***************************

  useEffect(() => {
    getEquipmentInfo();
    getInspectionTypes();
    getInspectionStatuses();
    getInspections();
    getMaintenances();
    getMaintenanceFormData();
    getInsurances();
    getInsurancesTypes();
  }, [eqId]);

  return (
    <>
      {/* ************************* inspection section modals ********************** */}
      {/* add inspection & update */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Edit Inspection" : "Add Inspection"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddInspection)}>
            {/* type & name & date */}
            <div className="row">
              {/* type */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Inspection Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Inspection Type"
                    {...register("type_id")}
                    value={addInspectionData.type_id}
                    onChange={(e) => {
                      setAddInspectionData({
                        ...addInspectionData,
                        type_id: e.target.value,
                      });
                    }}
                  >
                    {inspectionTypes?.map((ins) => (
                      <MenuItem
                        key={ins.id}
                        className="custom-menu-item"
                        value={ins.id}
                      >
                        {ins.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.type_id && (
                  <p className="danger">{errors.type_id.message}</p>
                )}
              </div>
              {/* name */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Inspector Name"
                  variant="outlined"
                  {...register("inspector_name")}
                  value={addInspectionData.inspector_name}
                  onChange={(e) => {
                    setAddInspectionData({
                      ...addInspectionData,
                      inspector_name: e.target.value,
                    });
                  }}
                />
                {errors.inspector_name && (
                  <p className="danger">{errors.inspector_name.message}</p>
                )}
              </div>
              {/* date */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Inspection Date"
                  type="date"
                  value={addInspectionData.inspection_date}
                  {...register("inspection_date")}
                  onChange={(e) =>
                    setAddInspectionData({
                      ...addInspectionData,
                      inspection_date: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            {/* status*/}
            <div className="row">
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addInspectionData.status}
                    onChange={(e) => {
                      setAddInspectionData({
                        ...addInspectionData,
                        status: e.target.value,
                      });
                    }}
                  >
                    {inspectionStatuses?.map((status) => (
                      <MenuItem
                        className="custom-menu-item"
                        key={status}
                        value={status}
                      >
                        {status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-4"
              label="Inspection Notes"
              variant="outlined"
              rows={4}
              multiline
              {...register("notes")}
              value={addInspectionData.notes}
              onChange={(e) => {
                setAddInspectionData({
                  ...addInspectionData,
                  notes: e.target.value,
                });
              }}
            />
            {errors.notes && <p className="danger">{errors.notes.message}</p>}
            {/* images */}
            <div className="mb-4">
              <div className=" d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Attachments</label>
                <input
                  type="file"
                  id="galleryImages"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    const validFiles = selectedFiles.filter((file) =>
                      [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "image/gif",
                        "image/svg+xml",
                      ].includes(file.type)
                    );

                    if (validFiles.length !== selectedFiles.length) {
                      toast.error(
                        "Some files were skipped (invalid image types)"
                      );
                    }

                    const newImages = validFiles.map((file) => ({
                      file,
                      preview: URL.createObjectURL(file),
                      isFromBackend: false,
                    }));

                    setImages((prev) => [...prev, ...newImages]);
                  }}
                />
                <label
                  htmlFor="galleryImages"
                  className="btn btn-light d-flex align-items-center gap-2"
                >
                  <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
                  Add Images
                </label>
              </div>
              <div className="d-flex justify-content-evenly align-items-center flex-wrap gap-2 mt-3">
                {images.map((img, index) => (
                  <div
                    key={index}
                    className="position-relative d-flex justify-content-center align-items-center my-1"
                    style={{
                      width: "22%",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      height: "100px",
                    }}
                  >
                    <img
                      src={img.preview}
                      alt={`preview-${index}`}
                      style={{
                        width: "90%",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setImages((prev) => prev.filter((_, i) => i !== index));
                        if (img.isFromBackend && img.id) {
                          setRemovedImages((prev) => [...prev, img.id]);
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                        paddingBottom: "4px",
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/*inspection GALLERY MODAL */}
      <Modal
        show={showInspectionGalleryModal}
        onHide={handleCloseInspectionGalleryModal}
        size="lg"
        centered
        dialogClassName="inspection-gallery-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{inspectionGalleryTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            gap: "20px",
            height: "70vh",
            padding: "20px",
            overflow: "hidden",
          }}
        >
          {inspectionGalleryImages && inspectionGalleryImages.length > 0 ? (
            <>
              {/* LEFT SIDE - BIG IMAGE */}
              <div
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "10px",
                  padding: "10px",
                  background: "#f8f9fa",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                }}
              >
                {inspectionSelectedImage ? (
                  <>
                    <img
                      src={`${newBaseUrl}${inspectionSelectedImage.image_url}`}
                      alt="Selected Inspection"
                      style={{
                        width: "100%",
                        height: "60vh",
                        objectFit: "contain",
                      }}
                    />
                    <Button
                      variant="dark"
                      size="sm"
                      onClick={() =>
                        handleDownloadInspectionImage(inspectionSelectedImage)
                      }
                      style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "20px",
                        display: "flex",
                        background: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        alignItems: "center",
                        gap: "5px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        borderRadius: "6px",
                      }}
                    >
                      <DownloadIcon fontSize="small" /> Download
                    </Button>
                  </>
                ) : (
                  <p>No images available.</p>
                )}
              </div>
              {/* RIGHT SIDE - THUMBNAILS */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  overflowY: "scroll",
                  paddingRight: "10px",
                }}
              >
                {inspectionGalleryImages.map((img, index) => (
                  <div
                    key={index}
                    onClick={() => setInspectionSelectedImage(img)}
                    style={{
                      cursor: "pointer",
                      height: "100px",
                      padding: "10px",
                      border:
                        inspectionSelectedImage === img
                          ? "2px solid #0d6efd"
                          : "2px solid #ccc",
                      borderRadius: "8px",
                      transition: "0.2s",
                      boxShadow:
                        inspectionSelectedImage === img
                          ? "0 0 5px rgba(13,110,253,0.5)"
                          : "0 0 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={`${newBaseUrl}${img.image_url}`}
                      alt={`Thumbnail ${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="mx-auto">
              <NotFound
                paragraphText={
                  "No Images yet. All your Images will appear here once you get started."
                }
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* ************************* maintenance section modals ********************** */}
      {/* add maintenance & update */}
      <Modal show={showMaintenance} onHide={handleCloseMaintenance} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isMaintenanceEditing ? "Edit Maintenance" : "Add Maintenance"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitMaintenance(onSubmitAddMaintenace)}>
            {/* id & performed & status */}
            <div className="row">
              {/* id */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="inspection-label">Inspection Id</InputLabel>
                  <Select
                    labelId="inspection-label"
                    label="Inspection Id"
                    {...maintenanceRegister("inspection_id")}
                    value={addMaintenanceData.inspection_id}
                    onChange={(e) => {
                      setAddMaintenanceData({
                        ...addMaintenanceData,
                        inspection_id: e.target.value,
                      });
                    }}
                  >
                    {inspections?.map((ins) => (
                      <MenuItem
                        className="custom-menu-item"
                        key={ins.id}
                        value={ins.id}
                      >
                        {ins.inspector_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {maintenanceErrors.inspection_id && (
                  <p className="danger">
                    {maintenanceErrors.inspection_id.message}
                  </p>
                )}
              </div>
              {/* performed by */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Performed by"
                  variant="outlined"
                  {...maintenanceRegister("performed_by")}
                  value={addMaintenanceData.performed_by}
                  onChange={(e) => {
                    setAddMaintenanceData({
                      ...addMaintenanceData,
                      performed_by: e.target.value,
                    });
                  }}
                />
                {maintenanceErrors.performed_by && (
                  <p className="danger">
                    {maintenanceErrors.performed_by.message}
                  </p>
                )}
              </div>
              {/* status */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...maintenanceRegister("status")}
                    value={addMaintenanceData.status}
                    onChange={(e) => {
                      setAddMaintenanceData({
                        ...addMaintenanceData,
                        status: e.target.value,
                      });
                    }}
                  >
                    {maintenanceStatuses &&
                      Object.entries(maintenanceStatuses).map(
                        ([key, value]) => (
                          <MenuItem
                            key={key}
                            className="custom-menu-item"
                            value={key}
                          >
                            {value}
                          </MenuItem>
                        )
                      )}
                  </Select>
                </FormControl>
                {maintenanceErrors.status && (
                  <p className="danger">{maintenanceErrors.status.message}</p>
                )}
              </div>
            </div>
            {/* sche , completed , type */}
            <div className="row">
              {/* scheduled */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Scheduled Date"
                  type="date"
                  value={addMaintenanceData.scheduled_at}
                  {...maintenanceRegister("scheduled_at")}
                  onChange={(e) =>
                    setAddMaintenanceData({
                      ...addMaintenanceData,
                      scheduled_at: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              {/* completed */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Completed Date"
                  type="date"
                  value={addMaintenanceData.completed_date}
                  {...maintenanceRegister("completed_date")}
                  onChange={(e) =>
                    setAddMaintenanceData({
                      ...addMaintenanceData,
                      completed_date: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              {/* type */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Type"
                    {...maintenanceRegister("type")}
                    value={addMaintenanceData.type}
                    onChange={(e) => {
                      setAddMaintenanceData({
                        ...addMaintenanceData,
                        type: e.target.value,
                      });
                    }}
                  >
                    {maintenanceTypes &&
                      Object.entries(maintenanceTypes).map(([key, value]) => (
                        <MenuItem
                          key={key}
                          className="custom-menu-item"
                          value={key}
                        >
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {maintenanceErrors.type && (
                  <p className="danger">{maintenanceErrors.type.message}</p>
                )}
              </div>
            </div>
            {/* cost */}
            <div className="row">
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Maintenance Cost"
                  variant="outlined"
                  {...maintenanceRegister("cost")}
                  value={addMaintenanceData.cost}
                  onChange={(e) => {
                    setAddMaintenanceData({
                      ...addMaintenanceData,
                      cost: e.target.value,
                    });
                  }}
                />
                {maintenanceErrors.cost && (
                  <p className="danger">{maintenanceErrors.cost.message}</p>
                )}
              </div>
            </div>
            {/* issue */}
            <div>
              <TextField
                className="w-100 mb-4"
                label="Issue Found"
                variant="outlined"
                rows={4}
                multiline
                {...maintenanceRegister("issues_found")}
                value={addMaintenanceData.issues_found}
                onChange={(e) => {
                  setAddMaintenanceData({
                    ...addMaintenanceData,
                    issues_found: e.target.value,
                  });
                }}
              />
              {maintenanceErrors.issues_found && (
                <p className="danger">
                  {maintenanceErrors.issues_found.message}
                </p>
              )}
            </div>
            {/* action */}
            <div>
              <TextField
                className="w-100 mb-4"
                label="Action Taken"
                variant="outlined"
                rows={4}
                multiline
                {...maintenanceRegister("actions_taken")}
                value={addMaintenanceData.actions_taken}
                onChange={(e) => {
                  setAddMaintenanceData({
                    ...addMaintenanceData,
                    actions_taken: e.target.value,
                  });
                }}
              />
              {maintenanceErrors.actions_taken && (
                <p className="danger">
                  {maintenanceErrors.actions_taken.message}
                </p>
              )}
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseMaintenance}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmittingMaintenance}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* ************************* insurance section modals ********************** */}
      {/* add insurance & update */}
      <Modal show={showInsurance} onHide={handleCloseInsurance} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isInsuranceEditing ? "Edit Insurance" : "Add Insurance"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitInsurance(onSubmitAddInsurance)}>
            {/* type & provider & date */}
            <div className="row">
              {/* type */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="type-label">Insurance Type</InputLabel>
                  <Select
                    labelId="type-label"
                    label="Insurance Type"
                    {...insuranceRegister("type_id")}
                    value={addInsuranceData.type_id}
                    onChange={(e) => {
                      setAddInsuranceData({
                        ...addInsuranceData,
                        type_id: e.target.value,
                      });
                    }}
                  >
                    {insurancesTypes?.map((ins) => (
                      <MenuItem
                        key={ins.id}
                        className="custom-menu-item"
                        value={ins.id}
                      >
                        {ins.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {insuranceErrors.type_id && (
                  <p className="danger">{insuranceErrors.type_id.message}</p>
                )}
              </div>
              {/* provider */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Provider"
                  variant="outlined"
                  {...insuranceRegister("provider")}
                  value={addInsuranceData.provider}
                  onChange={(e) => {
                    setAddInsuranceData({
                      ...addInsuranceData,
                      provider: e.target.value,
                    });
                  }}
                />
                {insuranceErrors.provider && (
                  <p className="danger">{insuranceErrors.provider.message}</p>
                )}
              </div>
              {/* date */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Expiry Date"
                  type="date"
                  value={addInsuranceData.expiry_date}
                  {...register("expiry_date")}
                  onChange={(e) =>
                    setAddInsuranceData({
                      ...addInsuranceData,
                      expiry_date: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            {/* amount & policy*/}
            <div className="row">
              {/* amount */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Amount"
                  variant="outlined"
                  {...insuranceRegister("amount")}
                  value={addInsuranceData.amount}
                  onChange={(e) => {
                    setAddInsuranceData({
                      ...addInsuranceData,
                      amount: e.target.value,
                    });
                  }}
                />
                {insuranceErrors.amount && (
                  <p className="danger">{insuranceErrors.amount.message}</p>
                )}
              </div>
              {/* policy */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Policy No."
                  variant="outlined"
                  {...insuranceRegister("policy_number")}
                  value={addInsuranceData.policy_number}
                  onChange={(e) => {
                    setAddInsuranceData({
                      ...addInsuranceData,
                      policy_number: e.target.value,
                    });
                  }}
                />
                {insuranceErrors.policy_number && (
                  <p className="danger">
                    {insuranceErrors.policy_number.message}
                  </p>
                )}
              </div>
            </div>
            {/* comment  */}
            <TextField
              className="w-100 mb-4"
              label="Comment"
              variant="outlined"
              rows={4}
              multiline
              {...insuranceRegister("comment")}
              value={addInsuranceData.comment}
              onChange={(e) => {
                setAddInsuranceData({
                  ...addInsuranceData,
                  comment: e.target.value,
                });
              }}
            />
            {insuranceErrors.comment && (
              <p className="danger">{insuranceErrors.comment.message}</p>
            )}
            {/* images */}
            <div className="mb-4">
              <div className=" d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Attachments</label>
                <input
                  type="file"
                  id="galleryImages"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    const validFiles = selectedFiles.filter((file) =>
                      [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "image/gif",
                        "image/svg+xml",
                      ].includes(file.type)
                    );

                    if (validFiles.length !== selectedFiles.length) {
                      toast.error(
                        "Some files were skipped (invalid image types)"
                      );
                    }

                    const newImages = validFiles.map((file) => ({
                      file,
                      preview: URL.createObjectURL(file),
                      isFromBackend: false,
                    }));

                    setInsuranceImages((prev) => [...prev, ...newImages]);
                  }}
                />
                <label
                  htmlFor="galleryImages"
                  className="btn btn-light d-flex align-items-center gap-2"
                >
                  <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
                  Add Images
                </label>
              </div>
              <div className="d-flex justify-content-evenly align-items-center flex-wrap gap-2 mt-3">
                {insuranceImages.map((img, index) => (
                  <div
                    key={index}
                    className="position-relative d-flex justify-content-center align-items-center my-1"
                    style={{
                      width: "22%",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      height: "100px",
                    }}
                  >
                    <img
                      src={img.preview}
                      alt={`preview-${index}`}
                      style={{
                        width: "90%",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setInsuranceImages((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                        if (img.isFromBackend && img.id) {
                          setInsuranceRemovedImages((prev) => [
                            ...prev,
                            img.id,
                          ]);
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                        paddingBottom: "4px",
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleCloseInsurance}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isInsuranceSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/*Insurance GALLERY MODAL */}
      <Modal
        show={showInsranceGalleryModal}
        onHide={handleCloseInsuranceGalleryModal}
        size="lg"
        centered
        dialogClassName="insurance-gallery-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{insuranceGalleryTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            gap: "20px",
            height: "70vh",
            padding: "20px",
            overflow: "hidden",
          }}
        >
          {insuranceGalleryImages && insuranceGalleryImages.length > 0 ? (
            <>
              {/* LEFT SIDE - BIG IMAGE */}
              <div
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "10px",
                  padding: "10px",
                  background: "#f8f9fa",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                }}
              >
                {insuranceSelectedImage ? (
                  <>
                    <img
                      src={`${newBaseUrl}${insuranceSelectedImage.image_url}`}
                      alt="Selected Insurance"
                      style={{
                        width: "100%",
                        height: "60vh",
                        objectFit: "contain",
                      }}
                    />
                    <Button
                      variant="dark"
                      size="sm"
                      onClick={() =>
                        handleDownloadImage(insuranceSelectedImage)
                      }
                      style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "20px",
                        display: "flex",
                        background: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        alignItems: "center",
                        gap: "5px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        borderRadius: "6px",
                      }}
                    >
                      <DownloadIcon fontSize="small" /> Download
                    </Button>
                  </>
                ) : (
                  <p>No images available.</p>
                )}
              </div>
              {/* RIGHT SIDE - THUMBNAILS */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  overflowY: "scroll",
                  paddingRight: "10px",
                }}
              >
                {insuranceGalleryImages.map((img, index) => (
                  <div
                    key={index}
                    onClick={() => setInsuranceSelectedImage(img)}
                    style={{
                      cursor: "pointer",
                      height: "100px",
                      padding: "10px",
                      border:
                        insuranceSelectedImage === img
                          ? "2px solid #0d6efd"
                          : "2px solid #ccc",
                      borderRadius: "8px",
                      transition: "0.2s",
                      boxShadow:
                        insuranceSelectedImage === img
                          ? "0 0 5px rgba(13,110,253,0.5)"
                          : "0 0 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={`${newBaseUrl}${img.image_url}`}
                      alt={`Thumbnail ${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="mx-auto">
              <NotFound
                paragraphText={
                  "No Images yet. All your Images will appear here once you get started."
                }
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* ************************** delete equipment ************************* */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={"Are you sure you want to delete this equipment?"}
        deleteFunction={deleteEquipment}
      />
      {/* ************************  unassignh equipment *******************  */}
      <SelectVehicleModal
        show={showVehicleModal}
        onHide={handleAssignHide}
        equipmentId={eqId}
        onSave={() => {
          getEquipmentInfo();
        }}
        isTransfered={false}
        currentVehicleId={equipmentInfo?.current_vehicle?.id}
      />
      <Modal show={showUnassign} onHide={handleUnassignClose} className="">
        <>
          <div className="text-center py-4">
            <h3>Unassign Equipment</h3>
          </div>
          <div className="text-center py-2  px-3">
            <h6 style={{ color: "#535353" }} className="fs-4">
              Are you sure you want to unassign{" "}
              <span className="fw-bold d-block">
                {equipmentInfo?.model?.name}
              </span>
            </h6>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-center gap-3 py-3">
              <button
                onClick={handleUnassignClose}
                className="btn btn-light px-5"
              >
                Cancel
              </button>
              <button
                onClick={unassignEquipment}
                className="btn btn-danger px-5"
              >
                Unassign Equipment
              </button>
            </div>
          </div>
        </>
      </Modal>
      <div className="min-vh-100 m-4">
        {/* header data */}
        <div className="row align-items-center mb-3">
          <div className="col-12 col-lg-4 col-xl-3 mb-2 mb-xl-0">
            <h5 className="fw-semibold">Equipment Profile</h5>
          </div>
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div
                className="w-100 rounded-3"
                style={{
                  WebkitOverflowScrolling: "touch",
                  overflowX: "auto",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => setValue(newValue)}
                    sx={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      paddingY: "1px",
                      height: "45px",
                      ".Mui-selected": {
                        fontWeight: 450,
                      },
                      ".MuiBottomNavigationAction-root": {
                        fontSize: "14px",
                        borderRadius: "6px",
                      },
                    }}
                  >
                    <BottomNavigationAction label="Inspection" />
                    <BottomNavigationAction label="Maintenance History" />
                    <BottomNavigationAction label="Insurance" />
                  </BottomNavigation>
                </Box>
              </div>
              <div className="text-md-end w-100 w-md-auto mt-3 mt-md-0">
                <button
                  onClick={
                    equipmentInfo?.current_vehicle
                      ? handleUnassignShow
                      : handleAssignShow
                  }
                  className={`btn px-3 py-2 ${
                    !equipmentInfo?.current_vehicle
                      ? "btn-success"
                      : "btn-danger"
                  }`}
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {!equipmentInfo?.current_vehicle
                    ? "Assign To Van"
                    : "Unassign Equipment"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* side & table */}
        <div className="row gy-4">
          {/* side */}
          <div className="col-12 col-lg-4 col-xl-3">
            <div className="text-center my-">
              <p
                style={{ width: "100px" }}
                className="rounded-5 bg-black text-white px-2 py-1"
              >
                {equipmentInfo?.current_vehicle
                  ? `On Van #${equipmentInfo?.current_vehicle?.id}`
                  : "Unassigned"}
              </p>
            </div>
            <div className=" p-2 h-100">
              <div
                style={{ height: "130px" }}
                className=" text-center p-3 mb-3"
              >
                <img
                  src={
                    equipmentInfo?.primary_image
                      ? `${newImageUrl}${equipmentInfo?.primary_image?.image_url}`
                      : defaultImage
                  }
                  alt="Profile"
                  className="img-fluid"
                  style={{ height: "100%" }}
                />
                <div>
                  <h5 className="fw-bold mt-2">{equipmentInfo?.model?.name}</h5>
                </div>
              </div>

              <div className="stuffprofileinfo_supplierProfile">
                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                  <h5 className="fw-semibold">Equipment Profile</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-1">
                      <div
                        className="categoryImgCard cursor"
                        onClick={() => console.log("Edit equipment")}
                      >
                        <img src={Pan} alt="Edit" />
                      </div>
                      <div
                        className="categoryImgCard cursor"
                        onClick={confirmDelete}
                      >
                        <img src={deleteIcon} alt="Delete" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Original Serial Number</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.manufacturer_serial_number}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">ESTBN Serial Number</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.internal_serial_number}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Current Condition</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.current_condition_status
                      ? equipmentInfo?.current_condition_status
                      : "-"}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Warranty</p>
                  <p className="fw-semibold m-0">
                    {new Date(
                      equipmentInfo?.warranty_expiry
                    ).toLocaleDateString()}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Acquisition Type</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.acquisition_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size">
                  <p className="main-text-color m-0">Date</p>
                  <p className="fw-semibold m-0">
                    {new Date(
                      equipmentInfo?.purchase_date
                    ).toLocaleDateString()}
                  </p>
                </div>
                <div className="">
                  <h5>Attachments:</h5>
                  <div className="row">
                    {equipmentInfo?.images?.map((image) => (
                      <div
                        style={{ border: "1px dashed #D8D8D8" }}
                        className="p-2 rounded-3 col-md-6"
                      >
                        <img
                          className="w-100"
                          src={
                            image.image_url
                              ? `${newImageUrl}${image.image_url}`
                              : defaultImage
                          }
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="stuffprofileinfo_supplierProfile mt-3">
                {equipmentInfo?.inspections ? (
                  <>
                    <div className="agentInfo-Supp">Recent Inspections</div>
                    {equipmentInfo?.inspections
                      ?.slice(0, 3)
                      .map((inspection) => (
                        <div
                          key={inspection?.id}
                          className="d-flex gap-2 align-items-center my-1"
                        >
                          <Square sx={{ fontSize: "10px" }} />
                          <p className="fw-semibold m-0">
                            {new Date(inspection.date).toLocaleDateString()} -{" "}
                            {inspection.status}
                          </p>
                        </div>
                      ))}{" "}
                  </>
                ) : (
                  ""
                )}
                {equipmentInfo?.maintenanceHistory ? (
                  <>
                    <div className="agentInfo-Supp mt-3">Maintenance</div>
                    {equipmentInfo?.maintenanceHistory
                      ?.slice(0, 3)
                      .map((maintenance) => (
                        <div
                          key={maintenance?.id}
                          className="d-flex gap-2 align-items-center my-1"
                        >
                          <Square sx={{ fontSize: "10px" }} />
                          <p className="fw-semibold m-0">
                            {new Date(maintenance.date).toLocaleDateString()} -{" "}
                            {maintenance.type}
                          </p>
                        </div>
                      ))}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/* <div className="col-12 col-lg-4 col-xl-3">
            <div className="text-center my-">
              <p
                style={{ width: "100px" }}
                className="rounded-5 bg-black text-white px-2 py-1"
              >
                {equipmentInfo?.current_vehicle
                  ? `On Van #${equipmentInfo?.current_vehicle?.id}`
                  : "Unassigned"}
              </p>
            </div>
            <div className=" p-2 h-100">
              <div
                style={{ height: "130px" }}
                className=" text-center p-3 mb-3"
              >
                <img
                  src={
                    equipmentInfo?.primary_image
                      ? `${"https://estbn.com/EstbnNew/public"}${
                          equipmentInfo?.primary_image?.image_url
                        }`
                      : defaultImage
                  }
                  alt="Profile"
                  className="img-fluid"
                  style={{ height: "100%" }}
                />
                <div>
                  <h5 className="fw-bold mt-2">{equipmentInfo?.model?.name}</h5>
                </div>
              </div>

              <div className="stuffprofileinfo_supplierProfile">
                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                  <h5 className="fw-semibold">Equipment Profile</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-1">
                      <div
                        className="categoryImgCard cursor"
                        onClick={() => console.log("Edit equipment")}
                      >
                        <img src={Pan} alt="Edit" />
                      </div>
                      <div
                        className="categoryImgCard cursor"
                        onClick={confirmDelete}
                      >
                        <img src={deleteIcon} alt="Delete" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Original Serial Number</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.manufacturer_serial_number}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">ESTBN Serial Number</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.internal_serial_number}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Current Condition</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.current_condition_status
                      ? equipmentInfo?.current_condition_status
                      : "-"}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Warranty</p>
                  <p className="fw-semibold m-0">
                    {new Date(
                      equipmentInfo?.warranty_expiry
                    ).toLocaleDateString()}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size ">
                  <p className="main-text-color m-0">Acquisition Type</p>
                  <p className="fw-semibold m-0">
                    {equipmentInfo?.acquisition_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center label-size">
                  <p className="main-text-color m-0">Date</p>
                  <p className="fw-semibold m-0">
                    {new Date(
                      equipmentInfo?.purchase_date
                    ).toLocaleDateString()}
                  </p>
                </div>
                <div className="">
                  <h5>Attachments:</h5>
                  <div className="row">
                    {equipmentInfo?.images?.map((image) => (
                      <div
                        style={{ border: "1px dashed #D8D8D8" }}
                        className="p-2 rounded-3 col-md-6"
                      >
                        <img
                          className="w-100"
                          src={
                            image.image_url
                              ? `${"https://estbn.com/EstbnNew/public"}${
                                  image.image_url
                                }`
                              : defaultImage
                          }
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="stuffprofileinfo_supplierProfile mt-3">
                {equipmentInfo?.inspections ? (
                  <>
                    <div className="agentInfo-Supp">Recent Inspections</div>
                    {equipmentInfo?.inspections
                      ?.slice(0, 3)
                      .map((inspection) => (
                        <div
                          key={inspection?.id}
                          className="d-flex gap-2 align-items-center my-1"
                        >
                          <Square sx={{ fontSize: "10px" }} />
                          <p className="fw-semibold m-0">
                            {new Date(inspection.date).toLocaleDateString()} -{" "}
                            {inspection.status}
                          </p>
                        </div>
                      ))}{" "}
                  </>
                ) : (
                  ""
                )}
                {equipmentInfo?.maintenanceHistory ? (
                  <>
                    <div className="agentInfo-Supp mt-3">Maintenance</div>
                    {equipmentInfo?.maintenanceHistory
                      ?.slice(0, 3)
                      .map((maintenance) => (
                        <div
                          key={maintenance?.id}
                          className="d-flex gap-2 align-items-center my-1"
                        >
                          <Square sx={{ fontSize: "10px" }} />
                          <p className="fw-semibold m-0">
                            {new Date(maintenance.date).toLocaleDateString()} -{" "}
                            {maintenance.type}
                          </p>
                        </div>
                      ))}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div> */}
          {/* tables */}
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="w-100 border border-2 rounded-3 p-3">
              {value === 0 ? (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <h5 className="m-0">Inspections</h5>
                    <button
                      className="btn btn-light"
                      onClick={() => handleShow()}
                    >
                      <Add /> Add Inspection
                    </button>
                  </div>
                  <div className="my-4">
                    <div className="scrollable-table-wrapper">
                      <div>
                        <Paper sx={{ width: "100%", height: 400 }}>
                          <DataGrid
                            rows={inspectionRows}
                            columns={inspectionColumns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            checkboxSelection
                            sx={{ border: 0 }}
                            slotProps={{
                              pagination: {
                                sx: {
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                },
                              },
                            }}
                          />
                        </Paper>
                      </div>
                    </div>
                  </div>
                </>
              ) : value === 1 ? (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <h5 className="m-0">Maintenance History</h5>
                    <button
                      className="btn btn-light"
                      onClick={() => handleShowMaintenance()}
                    >
                      <Add /> Log Maintenance
                    </button>
                  </div>
                  <div className="my-4">
                    <div className="scrollable-table-wrapper">
                      <div>
                        <Paper sx={{ width: "100%", height: 400 }}>
                          <DataGrid
                            rows={maintenanceRows}
                            columns={maintenanceColumns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            checkboxSelection
                            sx={{ border: 0 }}
                            slotProps={{
                              pagination: {
                                sx: {
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                },
                              },
                            }}
                          />
                        </Paper>
                        {/* <Paper sx={{ width: "100%", height: "auto" }}>
                          <DataGrid
                            rows={maintenanceRows}
                            columns={maintenanceColumns}
                            getDetailPanelContent={getDetailPanelContent}
                            getDetailPanelHeight={getDetailPanelHeight}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            checkboxSelection
                            sx={{ border: 0 }}
                            slotProps={{
                              pagination: {
                                sx: {
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                },
                              },
                            }}
                            onRowClick={(params) =>
                              setExpandedRow(
                                expandedRow === params.id ? null : params.id
                              )
                            }
                            getDetailPanelExpandedRowIds={[expandedRow]}
                          />
                        </Paper> */}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <h5 className="m-0">Insurance Policies</h5>
                    <button
                      className="btn btn-light"
                      onClick={() => handleShowInsurance()}
                    >
                      <Add /> Add Insurance
                    </button>
                  </div>
                  <div className="my-4">
                    <div className="scrollable-table-wrapper">
                      <div>
                        <Paper sx={{ width: "100%", height: 400 }}>
                          <DataGrid
                            rows={insurancesnRows}
                            columns={insurancesColumns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            checkboxSelection
                            sx={{ border: 0 }}
                            slotProps={{
                              pagination: {
                                sx: {
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                },
                              },
                            }}
                          />
                        </Paper>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewEQprofile;
